const mountDataCollectedOptionsIDs = (collectedOptions) => {
  return collectedOptions.map((val) => ({ id: val.id }))
}

export default mountDataCollectedOptionsIDs
